// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2iEhM","vLegacy":"SelectSecondary_vLegacy__k7Akh","error":"SelectSecondary_error__1G6-z","disabled":"SelectSecondary_disabled__1QTiR"};